<template>
	<div class="report-form-filter">
		<div class="btn-box">
			<div class="filter-setting-btn fx-cursor" :class="{'is-active': settingMenuVisible}" @click="settingMenuClickHandler"></div>
			<el-button type="primary" size="mini" class="search-btn" :disabled="reportAuthCpmuted" @click="searchHanlder">查询</el-button>
			<el-button size="mini" class="search-btn" plain :disabled="reportAuthCpmuted" @click="clearSearchHanlder">清空</el-button>
		</div>
		<div class="filters-box-slot">
			<slot name="filters"></slot>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	name: 'FiltersComp',
	props: {
		reportid: String,
		settingMenuVisible: {
			type: Boolean,
			default: false
		},
		gridCol: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			AuthorityList: {
				'09_0001_0000_00': false,
				'08_0002_0000_00': false
			},
			menu: []
		}
	},
	created () {
		this.getAuthority('09_0001_0000_00,09_0003_0000_00,09_0004_0000_00')
		// this.getAuthority('09_0003_0000_00')
		// this.getAuthority('09_0002_0000_00')
	},
	beforeDestroy () {
		this.$message.close()
	},
	watch: {
		reportAuth (val) {
			if (this.orderType === '商户报表') {
				if (!val[this.reportid]) {
					this.$message.error({
						message: `您没有查看${this.orderName}的权限!`,
						duration: 0
					})
				} else {
					this.$message.close()
				}
			}
		}
	},
	computed: {
		...mapState([
			'orderMenu',
			'orderType',
			// 'reportid',
			'orderName',
			'reportAuth'
		]),
		reportAuthCpmuted () {
			return this.orderType === '商户报表' ? !this.reportAuth[this.reportid] : false
		}
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					let menu = this.orderMenu
					for (let i = 0; i < a.length; i++) {
						for (let j = 0; j < menu.length; j++) {
							if (a[i] === menu[j].authority) {
								menu[j].show = true
							}
						}
					}
					this.menu = menu
				}
			})
		},
		settingMenuClickHandler () {
			this.$emit('memuClick')
		},
		clearSearchHanlder () {
			if (this.orderName === '预付货款余额查询表' || this.orderName === '订单支付流水对账明细表') {
				this.$emit('clearSearchClick')
				return false
			}
			let list = this.menu
			let flag = 0
			for (let i = 0; i < list.length; i++) {
				if (list[i].key.indexOf(this.reportid) !== -1) {
					if (list[i].show === true) {
						flag++
					}
				}
			}
			if (flag > 0) {
				this.$emit('clearSearchClick')
			} else {
				this.$message.error({
					message: `您没有查看${this.orderName}的权限!`
				})
			}
		},
		searchHanlder () {
			const colFlag = this.gridCol.some(item => {
				return item.showFlag
			})
			if (!colFlag) {
				this.$message.error('请勾选显示列')
				return false
			}
			if (this.orderName === '预付货款余额查询表' || this.orderName === '订单支付流水对账明细表') {
				// const colFlag = this.gridCol.some(item => {
				// 	return item.showFlag
				// })
				// if (colFlag) {
				// 	this.$emit('searchClick')
				// } else {
				// 	this.$message.error('请勾选显示列')
				// }
				this.$emit('searchClick')
				return false
			}
			let list = this.menu
			let flag = 0
			for (let i = 0; i < list.length; i++) {
				// console.log(list[i].key.indexOf(this.reportid) !== -1)
				if (list[i].key.indexOf(this.reportid) !== -1) {
					if (list[i].show === true) {
						flag++
					}
				}
			}
			if (flag > 0) {
				this.$emit('searchClick')
			} else {
				this.$message.error({
					message: `您没有查看${this.orderName}的权限!`
				})
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.report-form-filter {
	display:flex
	min-width 1300px;
	width:100%;
	flex-direction: row
	border-bottom: 1px solid #eee
	padding: 15px 20px;
	box-sizing: border-box
	.btn-box {
		display: flex;
		flex-direction: row;
		width:180px
		text-align:left
		margin-top:3px
		.filter-setting-btn {
			width:34px
			height:28px
			background-image:url('~images/icon/reportform/setting-menu-icon.png')
			background-repeat:no-repeat
			background-position: center
			background-size: cover
			border-top-right-radius: 5px
			border-bottom-right-radius: 5px
			&.is-active {
				background-image:url('~images/icon/reportform/setting-menu-close-icon.png')
			}
		}
		.search-btn {
			height: 28px;
			margin-left: 10px;
		}
	}
	.filters-box-slot {
		flex:1
	}
}
</style>

